import { DemographicResponses } from './DemographicResponses';
import { SurveyAssessmentViewModel } from './SurveyAssessmentViewModel';
import { AssessmentTimerData } from './AssessmentTimerData';

export class AssessmentProgress {
    public agreementAccepted: boolean;
    public termsOfServiceAccepted: boolean;
    public termsOfServiceDeclined: boolean;
    public demographicsSubmitted: boolean;
    public surveyCompleted: boolean;
    public demographicResponses?: DemographicResponses;
    public survey: SurveyAssessmentViewModel;
    public timerData?: AssessmentTimerData;
}


// WEBPACK FOOTER //
// ./src/models/AssessmentProgress.tsx